import { Component } from '@theme/component';
import { ThemeEvents } from '@theme/events';
import { StandardEvents } from '@shopify/events';
class PricePerItemComponent extends Component {
  #priceBreaks = [];
  #abortController = new AbortController();
  connectedCallback() {
    super.connectedCallback();
    this.#parsePriceBreaks();
    this.#attachEventListeners();
    this.#updatePriceDisplay();
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    this.#abortController.abort();
  }
  #parsePriceBreaks() {
    const minQuantity = parseInt(this.dataset.minQuantity || '') || 1;
    const { variantPrice: variantPrice, priceBreaks: priceBreaksData } =
      this.dataset;
    if (variantPrice) {
      this.#priceBreaks.push({ quantity: minQuantity, price: variantPrice });
    }
    if (priceBreaksData) {
      let breaks = [];
      try {
        breaks = JSON.parse(priceBreaksData);
      } catch (e) {
        console.warn('Failed to parse price breaks data:', e);
      }
      for (const { quantity: quantity, price: price } of breaks) {
        if (quantity && price) {
          this.#priceBreaks.push({
            quantity: parseInt(quantity),
            price: price,
          });
        }
      }
    }
    this.#priceBreaks.sort((a, b) => b.quantity - a.quantity);
  }
  #attachEventListeners() {
    const { signal: signal } = this.#abortController;
    document.addEventListener(
      ThemeEvents.quantitySelectorUpdate,
      this.#handleQuantityUpdate,
      { signal: signal },
    );
    document.addEventListener(
      StandardEvents.cartLinesUpdate,
      this.#handleCartUpdate,
      { signal: signal },
    );
  }
  #handleQuantityUpdate = (event) => {
    const form = this.closest('product-form-component');
    if (
      !form ||
      !(event.target instanceof Node) ||
      !form.contains(event.target)
    )
      return;
    this.#updatePriceDisplay();
  };
  #handleCartUpdate = (event) => {
    event.promise
      ?.then(() => this.#updatePriceDisplay())
      .catch((error) => {
        if (error?.name !== 'AbortError')
          console.warn('[price-per-item] Cart update promise rejected:', error);
      });
  };
  #getCurrentQuantity() {
    const form = this.closest('product-form-component');
    const quantityInput = form?.querySelector('input[name="quantity"]');
    if (!quantityInput) return 1;
    const cartQty =
      parseInt(quantityInput.getAttribute('data-cart-quantity') || '0') || 0;
    const inputQty = parseInt(quantityInput.value) || 1;
    return cartQty + inputQty;
  }
  updatePriceDisplay() {
    if (!this.#priceBreaks.length || !this.refs.pricePerItemText) return;
    const quantity = this.#getCurrentQuantity();
    const priceBreak =
      this.#priceBreaks.find((pb) => quantity >= pb.quantity) ??
      this.#priceBreaks[this.#priceBreaks.length - 1];
    if (priceBreak) {
      this.refs.pricePerItemText.textContent = `${this.dataset.atText} ${priceBreak.price}/${this.dataset.eachText}`;
    }
  }
  #updatePriceDisplay = () => {
    this.updatePriceDisplay();
  };
}
if (!customElements.get('price-per-item')) {
  customElements.define('price-per-item', PricePerItemComponent);
}
